/* Injects oxx-ic-engineer-skin.css into the Engineer Pro shadow root(s) and re-asserts the v2 type scale on
   key controls. The older readability layer (oxx-engineer-pro-ui-v4.js) writes inline
   `font-size: 12px !important` on links/spans, which no stylesheet can override; this file sets the
   v2 sizes inline after it, and again whenever the tool re-renders. Read-only towards the tool's logic:
   it only changes presentation properties. */
(function () {
  'use strict';
  var HOST = '[data-oxx-engineer-pro-root]';
  var ID = 'oxx-ic-engineer-skin';
  // selector -> [font-size, line-height]
  var TYPE = [
    ['.action-primary, .action-quote, .action-secondary, .action-utility', '14.5px', '20px'],
    ['nav[aria-label="Sealing mode"] button', '14px', '20px'],
    ['.results-hero h2', '24px', '30px'],
    ['section[aria-label="Next steps"] h3', '20px', '26px'],
    ['.kpi-card .numeric.leading-none', '44px', '46px'],
    ['section[aria-label="Inputs"] p.label-caps', '12.5px', '18px'],
    ['.rounded-full.numeric', '12px', '16px']
  ];
  function href() {
    var s = document.querySelector('script[data-oxx-ic-engineer-skin]');
    return s ? s.getAttribute('data-css') : '';
  }
  /* Buyer language for internal QA states (WP5). Only text-node values are rewritten, in place: the node React
     owns stays the same object, so when the kernel later changes a state it writes the new value into that node,
     the observer sees the characterData change and maps it again. No logic, attribute or output is touched;
     data-unified-state / aria-labels keep the kernel's values. */
  var EXACT = {
    'HOLD': 'Needs engineering review',
    'NOT EVALUATED': 'Not checked yet',
    'REVIEW': 'Check recommended',
    'SUPPORTED CANDIDATE': 'No issues flagged',
    'Unified state:': '',
    'Key blockers / review items': 'Before we can confirm:',
    '▲': '', '●': '',
    '— HOLD': '– needs engineering review',
    '— REVIEW': '– check recommended',
    'HOLD GUIDANCE': 'Needs review',
    'REVIEW GUIDANCE': 'Worth checking',
    'Next: resolve HOLD / REVIEW items before release.': 'Next: send the case for review, or adjust the inputs above.',
    'No blocking or review items reported by the mirrored subsystem states.': 'Nothing flagged in this check.',
    'Gland estimator on hold - engineering validation pending': 'Groove estimator not available yet: enter your groove dimensions',
    'Geometry output on hold': 'Check the ring and groove dimensions',
    'Geometry calculation complete - recommendation limits remain under engineering validation': 'Geometry calculated against public reference ranges',
    'Catalog matching is on hold until the nominal ring size is valid.': 'Enter a valid ring size to match catalog stock.'
  };
  var PART = [
    [/\(not evaluated yet\)/g, '(not checked yet)'],
    [/Resolve HOLD\/REVIEW items in their authoritative panels before release\./g, 'Items marked for review are confirmed by our engineers before you order.'],
    [/recommendation limits are withheld pending engineering validation/g, 'results use public reference ranges, not approved design limits'],
    [/ · Blocking /g, ' · To confirm ']
  ];
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, OPTION: 1, SELECT: 1 };
  function mapText(node) {
    var v = node.nodeValue;
    if (!v || v.length > 400) return;
    var p = node.parentNode;
    if (!p || SKIP[p.nodeName]) return;
    var t = v.trim(), out = v;
    if (Object.prototype.hasOwnProperty.call(EXACT, t)) {
      var lead = /^\s/.test(v) && EXACT[t] ? ' ' : '';
      out = EXACT[t] ? lead + EXACT[t] + (/\s$/.test(v) ? ' ' : '') : '';
    } else {
      for (var i = 0; i < PART.length; i++) out = out.replace(PART[i][0], PART[i][1]);
    }
    if (out !== v) node.nodeValue = out;
  }
  function relabel(root) {
    if (root.nodeType === 3) { mapText(root); return; }
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) mapText(n);
  }
  function retype(sr) {
    for (var i = 0; i < TYPE.length; i++) {
      var nodes = sr.querySelectorAll(TYPE[i][0]);
      for (var j = 0; j < nodes.length; j++) {
        var st = nodes[j].style;
        if (st.getPropertyValue('font-size') !== TYPE[i][1]) st.setProperty('font-size', TYPE[i][1], 'important');
        if (st.getPropertyValue('line-height') !== TYPE[i][2]) st.setProperty('line-height', TYPE[i][2], 'important');
      }
    }
  }
  function skin(host) {
    var sr = host.shadowRoot;
    if (!sr) return false;
    if (!sr.getElementById(ID)) {
      var l = document.createElement('link');
      l.id = ID; l.rel = 'stylesheet'; l.href = href();
      sr.appendChild(l); // last, so it wins over the bundle's own style element
      host.setAttribute('data-oxx-skin', 'v2');
    }
    retype(sr);
    relabel(sr);
    if (!host.__oxxSkinObs) {
      var t = 0;
      host.__oxxSkinObs = new MutationObserver(function (records) {
        // relabel synchronously (before paint) so internal state words never flash
        for (var i = 0; i < records.length; i++) {
          var r = records[i];
          if (r.type === 'characterData') mapText(r.target);
          else if (r.type === 'childList') for (var j = 0; j < r.addedNodes.length; j++) relabel(r.addedNodes[j]);
        }
        window.clearTimeout(t); t = window.setTimeout(function () { retype(sr); }, 60);
      });
      host.__oxxSkinObs.observe(sr, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['style', 'class'] });
    }
    return true;
  }
  function run() {
    var hosts = document.querySelectorAll(HOST), pending = 0;
    for (var i = 0; i < hosts.length; i++) if (!skin(hosts[i])) pending++;
    return pending === 0 && hosts.length > 0;
  }
  var tries = 0;
  (function tick() { if (run() || ++tries > 80) return; window.setTimeout(tick, 100); })();
})();
